import { Table } from "reactstrap";
import { CheckMarkIcon } from "../../common/icons";
import './ws-client.scss';
import { useLazyQuery } from "@apollo/client";
import { IWsClient, IWsClientsResponse } from "../../../types/ws-admin";
import { GET_WS_CLIENTS } from "../../../graphql/ws-admin-gql";
import SpinnerOverlay from "../../common/spinner/spinner";
import { useEffect, useState } from "react";
import TableRow from "../../common/table-row";

type WsClientTableProps = {
  onClientSelect:( client: IWsClient) => void; //function passed from parent component to handle client selection 
}

const WsClientTable = ({onClientSelect}:  WsClientTableProps) => {

    const [getWsClients, { loading, data }] = useLazyQuery<IWsClientsResponse>(GET_WS_CLIENTS);

    const [selectedClient, setSelectedClient] = useState<IWsClient>()

    useEffect(() => {
        getWsClients()
    }, [])

    const onClientSelected = (client: IWsClient) => {
        setSelectedClient(client)
        onClientSelect(client)
    }

    const handleKeyDown = (event: any, client: IWsClient) => {
        if (event.key === 'Enter') {
            setSelectedClient(client)
        }
    };

    return (
        <>
        {loading && <SpinnerOverlay></SpinnerOverlay>}
        <div style={{maxHeight: '200px', overflowY: 'auto'}}>
            <Table striped className="fix-table-head">
                <thead>
                    <tr>
                        <th className="col-large">Client Name</th>
                        <th className="col-small text-center">Expired</th>
                    </tr>
                </thead>
                <tbody>
                
                    {data?.wsClients.map((c, index) => (
                        <TableRow key={index}
                            className={selectedClient?.clientId === c.clientId ? ' table-primary' : ' pe-force'}
                            onSelect={() => onClientSelected(c)}>
                            <td className='col-large'>{c.clientName}</td>
                            <td className='col-small text-center'>
                                {!c.active && <CheckMarkIcon />}
                            </td>
                        </TableRow>
                    ))}
                </tbody>
            </Table>
        </div>
        </>
    )
};

export default WsClientTable;
